import type { ModalPropsType } from "@components/@Portal/ModalContainer";

import type { Popup } from "@schemas/popup";

import { ModalClose } from "../Items";
import "./style.scss";

interface Props extends ModalPropsType {
	popup: Popup;
}

export default function PopupModal({ popup, onClose }: Props) {
	const align = popup.alignX;
	const posX = popup.posX;
	const posY = popup.posY;
	const width = popup.width;

	const style: React.CSSProperties = {
		top: posY,
		width,
	};
	if (align === "LEFT") style.left = posX;
	if (align === "RIGHT") style.right = posX;
	if (align === "CENTER") {
		style.left = "50%";
		style.transform = `translateX(-50%) translateX(${posX}px)`;
	}

	const target = popup.shouldOpenInNewTab ? "_blank" : "_self";

	const handleHideToday = () => {
		// 하루 보지 않기: 24시간 유지되는 쿠키로 저장
		try {
			const key = `popup-hide-${popup.id}`;
			const maxAge = 60 * 60 * 24; // 1 day
			document.cookie = `${key}=1; max-age=${maxAge}; path=/; samesite=Lax`;
		} catch {
			/* ignore */
		}
		onClose?.();
	};

	return (
		<div className="popup-modal" style={style} role="dialog" aria-modal="true">
			<button className="popup-modal__close" aria-label="닫기" onClick={onClose}>
				<ModalClose />
			</button>
			<a
				href={popup.imageLink}
				target={target}
				rel={popup.shouldOpenInNewTab ? "noopener noreferrer" : undefined}
			>
				<img
					draggable={false}
					className="popup-modal__image"
					src={popup.imageUrl}
					alt="popup"
				/>
			</a>
			<div className="popup-modal__footer">
				<button className="hide-today" onClick={handleHideToday}>
					오늘 하루 보지 않기
				</button>
			</div>
		</div>
	);
}
